import React from "react";
import Body from '../component/Body';

function Home() {
    return (
        <Body />
    )
}
export default Home;